<template>
    <transition name="pages">
        <!-- <keep-alive> -->
            <router-view></router-view>
        <!-- </keep-alive> -->
    </transition>
</template>

<script>
export default {
    name: "app",
    data() {
        return {
        }
    },
    mounted() {
        this.removeClass(document.body, "body");
        this.removeClass(document.body, "tema-2");
        this.removeClass(document.body, "tema-3");
        this.removeClass(document.querySelector("html"), "html");
    },
    methods: {
        removeClass(el, className) {
            if (el.classList)
            el.classList.remove(className);
            else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
    }
}
</script>

<style lang="scss">
    .pages-enter, .pages-leave-active {
        opacity: 0;
    }

    .pages-enter-active, .pages-leave-active {
        transition: opacity .3s;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue